import { DateTime } from 'luxon';
import { gql, useQuery } from '@apollo/client';
import {
  saleConfig as fallbackSaleConfig,
  calculateStage,
  saleStages,
  saleEndForStage
} from '../config/sale';

const TEST_SALE_PARAM = '__testSale__';

const SALE_CONFIG = gql`
  query saleConfig {
    saleConfig {
      early_access
      early_access_enabled
      sale_start
      last_chance
      surprise_extension
      last_day
      sale_end
      code
    }
  }
`;

const useSale = () => {
  const { data } = useQuery(SALE_CONFIG, { fetchPolicy: 'cache-and-network' });
  const apiConfig = data?.saleConfig;

  const config = apiConfig
    ? {
        earlyAccess:
          apiConfig.early_access_enabled && apiConfig.early_access
            ? DateTime.fromISO(apiConfig.early_access)
            : fallbackSaleConfig.earlyAccess,
        saleStart: apiConfig.sale_start
          ? DateTime.fromISO(apiConfig.sale_start)
          : fallbackSaleConfig.saleStart,
        lastChance: apiConfig.last_chance
          ? DateTime.fromISO(apiConfig.last_chance)
          : fallbackSaleConfig.lastChance,
        surpriseExtension: apiConfig.surprise_extension
          ? DateTime.fromISO(apiConfig.surprise_extension)
          : fallbackSaleConfig.surpriseExtension,
        lastDay: apiConfig.last_day
          ? DateTime.fromISO(apiConfig.last_day)
          : fallbackSaleConfig.lastDay,
        saleEnd: apiConfig.sale_end
          ? DateTime.fromISO(apiConfig.sale_end)
          : fallbackSaleConfig.saleEnd,
        code: apiConfig.code ?? fallbackSaleConfig.code
      }
    : fallbackSaleConfig;

  const saleStage = calculateStage(testSaleDate() || getNow(), config);
  const { saleStart } = config;

  return {
    isSale: !!saleStage,
    saleStage,
    saleStart,
    saleEnd: saleEndForStage(saleStage, config),
    code: config.code
  };
};

function getNow() {
  return DateTime.now().setZone('America/Denver');
}

function testSaleDate() {
  if (window) {
    const params = new URLSearchParams(window.location.search);

    if (params.get(TEST_SALE_PARAM)) {
      return DateTime.fromISO(params.get(TEST_SALE_PARAM));
    }
  }

  return null;
}

export default useSale;
export { saleStages };
